const { getApproveStatusName } = require('../approveStatus')

const baseMixin = {
  data() {
    return {
      form: {}, // 审批基础数据
      auditList: [], // 审批记录
    }
  },
  created() {
    this.config.push(
      ...[
        {
          component: 'ZlmTitle',
          options: {
            size: 'medium',
            text: '审核记录',
          },
        },
        {
          component: 'ZlmTabDetail',
          options: {
            title: '记录',
            data: [],
          },
        },
      ],
    )
    this.setButton()
    this.getApproveInfo()
  },
  methods: {
    setButton() {
      // 0-待审核 1-审核中
      switch (this.$route.query.approveStatus) {
        case 0:
        case '0':
          this.$parent.showButton = true
          break
        default:
          this.$parent.showButton = false
          break
      }
    },
    getApproveInfo() {
      this.$request
        .post(`/transformToAfter/app/approve/record/approvePage`, {
          approveRecordId: this.$route.query.id,
        })
        .then((res) => {
          if (res.data) {
            // 审批状态 0-未审批  1-审批通过  2-审批驳回  3-流程撤回 4-项目经理选择下步执行人
            // if (res.data.statusMsg === null) {
            //     this.$parent.showButton = false
            // } else {
            //     this.$parent.showButton = !res.data.statusMsg
            // }
            this.form = res.data
            this.$set(this.form, 'approveRecordId', this.$route.query.id)
            console.log(this.form)
            this.getData()
            this.getAuditList()
          }
        })
    },
    getAuditList() {
      this.$request
        .post(
          `/transformToAfter/gt-jy-jianguan/api/approveFlow/getApproveRecordByBusKey.do`,
          {
            businessKey: this.form.businessKey,
          },
        )
        .then((res) => {
          if (res.data && res.data.length > 0) {
            this.config[this.config.length - 1].options.data = res.data.map(
              (t) => ({
                提交人: t.commitUserName,
                提交事件: this.$util.timeFormatter(t.commitTime),
                审批人: t.approveUserName,
                审批结果: getApproveStatusName(t.statusMsg),
                审核时间: this.$util.timeFormatter(t.approveTime),
                审批意见: t.opinion,
              }),
            )
          }
        })
    },
    commit(filter = {}) {
      if (this.form.isLastNode === 0 && filter.opValue !== '2') {
        // 不是最后一个审批人
        this.$router.push({
          name: 'ApproverList',
          query: {
            title: '审批人',
          },
        })
      } else {
        // 审核
        this.$request
          .post(`/transformToAfter/app/approve/record/complete`, {
            approveRecordId: this.form.approveRecordId,
            approveUserId: this.form.currentUserId,
            approveUserName: this.form.currentUserName,
            opValue: '1', // 通过
            ...filter,
          })
          .then((res) => {
            if (res.code === 1) {
              this.$successInfo(res.data)
              // 完成后停留当前页,刷新信息
              this.$parent.showButton = false
              // eslint-disable-next-line no-undef
              native.postMessage(
                JSON.stringify({
                  message: '审批完成',
                  type: 'agency',
                }),
              )
              // this.$router.go(-1)
            } else {
              this.$errorInfo(res.data)
            }
          })
      }
    },

    // 项目签报审批
    projectCommit(filter = {}) {
      this.$request
        .post(
          `/transformToAfter/gt-jy-jianguan/api/xiangMuQianBao/getQianBaoShenHe.do`,
          {
            guid: this.form.approveRecordId,
            status: 1,
            ...filter,
          },
        )
        .then((res) => {
          if (res.code === 1) {
            this.$successInfo(res.data)
            // 完成后停留当前页,刷新信息
            this.$parent.showButton = false
            // this.$router.go(-1)
          } else {
            this.$errorInfo(res.data)
          }
        })
    },
    // 项目备案审批
    projectFilingCommit(filter = {}) {
      this.$request
        .post(
          `/transformToAfter/app/project/signBeiAn/getQianBaoBeiAnShenHe`,
          {
            guid: this.form.approveRecordId,
            status: 1,
            ...filter,
          },
        )
        .then((res) => {
          if (res.data === 1) {
            this.$successInfo('提交成功')
            // 完成后停留当前页,刷新信息
            this.$parent.showButton = false
            // this.$router.go(-1)
          } else {
            this.$errorInfo(res.info)
          }
        })
    },
    // 招采(集采)计划TODO
    planReportApprove(data) {
      this.$request
        .post(`/transformToAfter/app/bid/pro/plan/planReportApprove`, data)
        .then((res) => {
          if (res.code === 1) {
            this.$successInfo('提交成功')
            // 完成后停留当前页,刷新信息
            this.$parent.showButton = false
            // this.$router.go(-1)
          } else {
            this.$errorInfo(res.data)
          }
        })
    },
    // 采购失败审批
    failedCommit(filter = {}) {
      this.$request
        .post(`/transformToAfter/gt-jy-zhaobiao/api/approveFlow/complete.do`, {
          approveRecordId: this.form.approveRecordId,
          approveUserId: this.form.currentUserId,
          approveUserName: this.form.currentUserName,
          nextUserId: '',
          nextUserName: '',
          qmContent: '',
          qmResult: '',
          opValue: '1', // 1 通过 2 不通过
          opinion: '',
          ...filter,
        })
        .then((res) => {
          if (res.code === 1) {
            this.$successInfo(res.data)
            // 完成后停留当前页,刷新信息
            this.$parent.showButton = false
            // this.$router.go(-1)
          } else {
            this.$errorInfo(res.data)
          }
        })
    },
  },
}

module.exports = {
  baseMixin,
}
